var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolContactCenterIvr01 = function SvgSolContactCenterIvr01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_contact_center_ivr-01_svg2__a",
    x1: 14.92,
    x2: 109.79,
    y1: 81.22,
    y2: -15.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_contact_center_ivr-01_svg2__a",
    id: "sol_contact_center_ivr-01_svg2__b",
    x1: 20.82,
    x2: 115.69,
    y1: 86.98,
    y2: -10.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_contact_center_ivr-01_svg2__a",
    id: "sol_contact_center_ivr-01_svg2__c",
    x1: 26.71,
    x2: 121.58,
    y1: 92.74,
    y2: -4.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_contact_center_ivr-01_svg2__a",
    id: "sol_contact_center_ivr-01_svg2__d",
    x1: 20.41,
    x2: 115.28,
    y1: 86.59,
    y2: -10.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_contact_center_ivr-01_svg2__a",
    id: "sol_contact_center_ivr-01_svg2__e",
    x1: 20.85,
    x2: 115.72,
    y1: 87.02,
    y2: -10.11
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_contact_center_ivr-01_svg2__a",
    id: "sol_contact_center_ivr-01_svg2__f",
    x1: 115.14,
    x2: 210.01,
    y1: 179.12,
    y2: 81.99
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_contact_center_ivr-01_svg2__a",
    id: "sol_contact_center_ivr-01_svg2__g",
    x1: 99.41,
    x2: 194.28,
    y1: 163.75,
    y2: 66.62
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M55 43.07a2.88 2.88 0 1 0-.001-5.761A2.88 2.88 0 0 0 55 43.07",
    style: {
      fill: "url(#sol_contact_center_ivr-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.52 43.07a2.88 2.88 0 1 0-.001-5.761 2.88 2.88 0 0 0 .001 5.761",
    style: {
      fill: "url(#sol_contact_center_ivr-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 43.07a2.88 2.88 0 1 0-.001-5.761 2.88 2.88 0 0 0 .001 5.761",
    style: {
      fill: "url(#sol_contact_center_ivr-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.51 97.8V86.28c0-1.27-.81-2.4-2.02-2.8l-17.24-5.76c-.86-.29-1.82-.16-2.58.34l-7.3 4.86c-7.83-3.73-17.08-12.89-20.78-20.59l4.86-7.29c.51-.76.63-1.71.34-2.58l-5.76-17.24a2.95 2.95 0 0 0-2.8-2.02H8.71c-4.81 0-8.72 3.89-8.72 8.68 0 33.23 31.51 64.64 64.83 64.64 4.78 0 8.68-3.91 8.68-8.72ZM5.91 41.88c0-1.55 1.23-2.76 2.81-2.76h9.39l4.63 13.85-4.96 7.44c-.54.81-.65 1.83-.28 2.74 3.92 9.8 16.11 21.9 26.08 25.88.9.36 1.93.25 2.74-.28l7.44-4.96 13.85 4.63v9.39c0 1.57-1.21 2.81-2.77 2.81-30.29 0-58.92-28.54-58.92-58.73Z",
    style: {
      fill: "url(#sol_contact_center_ivr-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.04 60.21v8.78c0 1.2.72 2.27 1.82 2.73a2.928 2.928 0 0 0 3.22-.64l10.66-10.66h10.3c11.27 0 20.43-9.08 20.43-20.24S89.3 19.94 78.04 19.94H55c-11.16 0-20.24 9.08-20.24 20.24 0 10.16 7.52 18.59 17.28 20.02ZM55 25.86h23.04c8.01 0 14.52 6.43 14.52 14.33s-6.51 14.33-14.52 14.33H66.52c-.78 0-1.54.31-2.09.87l-6.48 6.48v-4.39a2.96 2.96 0 0 0-2.96-2.96c-7.9 0-14.33-6.43-14.33-14.33s6.43-14.33 14.33-14.33Z",
    style: {
      fill: "url(#sol_contact_center_ivr-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.64 147.36c-4.81 0-8.73 3.92-8.73 8.73s3.92 8.73 8.73 8.73 8.73-3.92 8.73-8.73-3.92-8.73-8.73-8.73m0 12.86a4.131 4.131 0 0 1 0-8.26 4.131 4.131 0 0 1 0 8.26",
    style: {
      fill: "url(#sol_contact_center_ivr-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7 175.46h-2.3v-34.21c0-8.96-5.3-17.1-13.52-20.74l-12.11-5.19c2.95-.93 5.61-2.59 7.77-4.89 3.27-3.47 5.14-8.17 5.14-12.91 0-4.35-1.52-8.46-4.4-11.88-3.6-4.27-5.58-9.71-5.58-15.3V59.33c0-9.64-3.75-18.7-10.57-25.52s-15.88-10.57-25.52-10.57c-19.9 0-36.09 16.19-36.09 36.09v10.65c0 5.78-2.27 11.31-5.97 15.76-4.65 5.6-5.62 13.17-2.52 19.76 2.3 4.89 6.44 8.41 11.4 9.89l-12.02 5.23a22.63 22.63 0 0 0-13.88 20.9v27.04a2.3 2.3 0 0 0 4.6 0v-27.04c0-7.3 4.35-13.84 11.1-16.68l15.07-6.55v13.83h-6.92c-1.95 0-3.82.83-5.12 2.28a6.93 6.93 0 0 0-1.73 5.33l3.79 35.72H45.49a2.3 2.3 0 0 0 0 4.6H197.7a2.3 2.3 0 0 0 0-4.6ZM174.78 88.6c2.17 2.58 3.32 5.67 3.32 8.92 0 3.58-1.42 7.14-3.89 9.76-2.62 2.78-6.21 4.31-10.13 4.31h-2.99l-3.93-1.69a10.48 10.48 0 0 1-6.26-8.27c7.09-3.82 11.92-11.31 11.92-19.9V64.46c.67.05 1.34.07 2.01.07 1.1 0 2.21-.06 3.3-.19v5.98c0 6.67 2.37 13.15 6.66 18.26Zm-37.6 36.26c-8.22.15-16.37-.9-24.28-3.09v-5.47l.66-.29h.02l4.1-1.78c4.56-1.98 7.78-6.04 8.76-10.79 2 .58 4.11.9 6.3.9h7.48c2.19 0 4.31-.32 6.32-.91 1.01 4.72 4.24 8.75 8.81 10.71l4.37 1.87.32.14v5.17a85.2 85.2 0 0 1-22.87 3.54Zm22.87 1.24v6.02H112.9v-5.6a90 90 0 0 0 22.79 2.94c.52 0 1.05 0 1.58-.01 7.71-.13 15.37-1.26 22.79-3.35Zm8.07-66.38c-6.33.85-13.46-.84-18.37-4.65-1-.78-2.45-.59-3.22.41-.78 1-.59 2.45.41 3.22 3.21 2.49 7.09 4.24 11.28 5.13v12.5c-1.1 2.52-2.33 4.61-5.1 6.89q-1.755 1.44-3.81 2.4a6.73 6.73 0 0 0-5.99-3.67h-5.38c-3.71 0-6.73 3.02-6.73 6.73s3.02 6.73 6.73 6.73h5.38c3.12 0 5.76-2.14 6.51-5.03 3.07-1.17 8.08-5.35 8.08-5.35-1.56 8.35-8.89 14.69-17.69 14.69h-7.49c-9.92 0-18-8.07-18-18V63.97a61.5 61.5 0 0 0 21.93-7.86c10.29-6.09 16.89-14.04 20.88-20.33 6.82 6.07 10.69 14.77 10.57 23.93Zm-22.67 28.96c0 1.19-.96 2.15-2.14 2.15h-5.38c-1.18 0-2.14-.96-2.14-2.14s.96-2.14 2.14-2.14h5.38c1.18 0 2.13.96 2.14 2.13m-40.32-29.35c0-17.37 14.13-31.49 31.49-31.49 6.23 0 12.18 1.8 17.26 5.14-3.67 5.88-9.84 13.43-19.56 19.18-6.67 3.94-13.98 6.46-21.74 7.49h-7.46v-.32Zm-8.92 44.22c-2.33-4.96-1.6-10.66 1.89-14.87 4.39-5.29 7.03-11.82 7.03-18.69v-5.73h5.01v17.49c0 8.6 4.83 16.1 11.93 19.91-.44 3.66-2.79 6.86-6.23 8.36l-3.65 1.59h-3.33c-5.48 0-10.33-3.08-12.66-8.04Zm79.96 35.7-3.84 36.2h-69.39l-3.84-36.2c-.07-.66.14-1.29.58-1.78s1.05-.76 1.71-.76h72.5c.66 0 1.27.27 1.71.76s.65 1.12.58 1.78Zm14.64 36.21h-13.86l3.79-35.72c.21-1.94-.42-3.88-1.73-5.33a6.89 6.89 0 0 0-5.12-2.28h-9.24v-14.01l15.41 6.6c6.54 2.9 10.76 9.39 10.76 16.53v34.21Z",
    style: {
      fill: "url(#sol_contact_center_ivr-01_svg2__g)"
    }
  }));
};
export default SvgSolContactCenterIvr01;